/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import _ from 'lodash';
import React, { Component, ReactComponentElement } from 'react';
import { CardModel } from 'src/types/card.model';
import CardService from '../../services/card.service';

// ours
import { ButtonPrimary, ButtonSecondary } from '@americanexpress/dls-react';

// styles
import styles from './BottomButtons.module.scss';
import { FullUserModel } from 'src/types/user.model';

interface BottomButtonsProps {
    drawerProps: any;
    showLoader: (message?: string) => void;
    hideLoader: (message?: string) => void;
    handleUpdateCard: (card?: CardModel, user?: FullUserModel, reloadDrawer?: Boolean) => void | Promise<void>;
    handleDeleteCard?: (card: CardModel) => Promise<void> | void;
    handleBack: () => void;

    updateAction?: () => void;
    setUpdated?: boolean;
    afterUpdateAction?: (card: CardModel) => Promise<void>;
    noDelete?: boolean;
    primaryButtonText?: string;
    deleteButtonText?: string;

    // these three should be deprecated and probably can be deleted
    wantsSavingsGoal?: boolean;
    handleCreateLinkedSavingsCard?: (card: CardModel) => void;
    handleOpenCard?: (card: CardModel) => void;
    disableUpdate?: boolean;
}

export default class BottomButtons extends Component<BottomButtonsProps, any> {
    /// ////////////////
    // Onced Methods //
    /// ////////////////
    private readonly handleDeleteOnce: () => void = _.once(async () => {
        await this.props.handleDeleteCard(this.props.drawerProps.card);
    });

    private readonly handleUpdateOnce: () => void = _.once(async () => {
        try {
            let savingsGoal: CardModel = null;
            let skip: boolean = true;

            if (this.props.updateAction) this.props.updateAction();
            if (this.props.setUpdated) this.props.drawerProps.card.updated = Date.now();
            if (this.props.wantsSavingsGoal && !CardService.getSavingsGoal(this.props)) {
                try {
                    this.props.showLoader('Building a savings plan...');
                    await this.props.handleUpdateCard();
                    await this.props.handleCreateLinkedSavingsCard(this.props.drawerProps.card);
                    savingsGoal = CardService.getSavingsGoal(this.props);
                    if (savingsGoal) this.props.handleOpenCard(savingsGoal);
                } finally {
                    this.props.hideLoader();
                    skip = false;
                }
            } else {
                await this.props.handleUpdateCard();
            }

            if (skip && this.props.afterUpdateAction) {
                await this.props.afterUpdateAction(savingsGoal);
            }
            if (skip && !this.props.afterUpdateAction) {
                await this.props.handleBack();
            }
        } catch (error) {
            console.error('error in BottomButtons', error); // left in intentionally
        }
    });

    public override render(): ReactComponentElement<any> {
        return (
            <div className={styles.bottomButtons} data-cy="bottomButtons">
                <ButtonPrimary disabled={this.props.disableUpdate} onClick={() => this.handleUpdateOnce()}>
                    {this.props.primaryButtonText ||
                        (this.props.wantsSavingsGoal && !CardService.getSavingsGoal(this.props)
                            ? 'Next: Adjust savings goal'
                            : 'Update')}
                </ButtonPrimary>
                {!this.props.noDelete && (
                    <ButtonSecondary onClick={() => this.handleDeleteOnce()}>
                        {this.props.deleteButtonText || 'Delete'}
                    </ButtonSecondary>
                )}
            </div>
        );
    }
}
